module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b5QEq"))).then(() => parcelRequire('f4eak'));